export const breakpoint = 736
export const listColumnsLargeScreen = 3
